import { Slide } from "react-reveal";
import FaqCardList from "../reusables/FaqCardList";
import FaqCard from "../reusables/FaqCard";
import OtherFAQs from "../reusables/OtherFAQs";

const DigitalMarketingFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How long does it take to see results from digital marketing?">
                  <p>It depends on the channel:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Paid ads: Results can start within days</span>
                    </li>
                    <li>
                      <span>
                        SEO: Typically 1–3 months for noticeable growth
                      </span>
                    </li>
                    <li>
                      <span>Full strategy: Compounding results over time</span>
                    </li>
                  </ul>
                  <p>
                    We combine both short-term and long-term strategies for
                    consistent growth.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What’s the difference between SEO and paid advertising?">
                  <p>The difference between SEO and paid advertising is:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>SEO brings free, organic traffic over time</span>
                    </li>
                    <li>
                      <span>
                        Paid ads bring immediate traffic but require budget
                      </span>
                    </li>
                  </ul>
                  <p>
                    The best results come from combining both strategically.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do you ensure my marketing budget is not wasted?">
                  <p>We focus on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Targeting the right audience</span>
                    </li>
                    <li>
                      <span>Continuous testing and optimization</span>
                    </li>
                    <li>
                      <span>Tracking every click, lead, and conversion</span>
                    </li>
                  </ul>
                  <p>Every decision is data-driven to maximize ROI.</p>
                </FaqCardList>
                <FaqCardList faq="Will I get actual customers or just traffic?">
                  <p>
                    Our focus is not just traffic—it’s conversions. We optimize
                    for:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Leads</span>
                    </li>
                    <li>
                      <span>Sales</span>
                    </li>
                    <li>
                      <span>Customer acquisition</span>
                    </li>
                  </ul>
                  <p>
                    Traffic without conversion is useless—we focus on results.
                  </p>
                </FaqCardList>
                <FaqCard
                  faq="Can you work with my existing website?"
                  answer="Yes, if it passes our review test. Otherwise, we recommend
                    improvements and then design a landing page for you, applying
                    best practices, integrations and strategies to serve the end
                    goal or design a new website afresh depending on your
                    budget goals."
                ></FaqCard>
                <FaqCardList faq="Do I need to be active on social media?">
                  <p>It depends on your business.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Some businesses benefit heavily</span>
                    </li>
                    <li>
                      <span>Others rely more on SEO or ads</span>
                    </li>
                  </ul>
                  <p>We guide you on where your audience actually is.</p>
                </FaqCardList>
                <FaqCardList faq="How do you track and measure results?">
                  <p>We set up:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Google Analytics</span>
                    </li>
                    <li>
                      <span>Conversion tracking</span>
                    </li>
                    <li>
                      <span>Campaign performance dashboards</span>
                    </li>
                    <li>
                      <span>Meta Pixels</span>
                    </li>
                  </ul>
                  <p>You’ll see exactly what’s working and what’s not.</p>
                </FaqCardList>
                <FaqCardList faq="What is conversion optimization (CRO), and why is it important?">
                  <p>
                    CRO focuses on turning visitors into customers by improving:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Landing pages</span>
                    </li>
                    <li>
                      <span>User experience</span>
                    </li>
                    <li>
                      <span>Calls-to-action</span>
                    </li>
                  </ul>
                  <p>This increases revenue more than traffic.</p>
                </FaqCardList>
                <FaqCardList faq="Can digital marketing work for any business?">
                  <p>Yes—but strategy matters. We tailor marketing based on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Your industry</span>
                    </li>
                    <li>
                      <span>Your audience</span>
                    </li>
                    <li>
                      <span>Your goals</span>
                    </li>
                  </ul>
                  <p>There is no one-size-fits-all approach.</p>
                </FaqCardList>
                <FaqCardList faq="How much should I budget for digital marketing?">
                  <p>Budget depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Your goals</span>
                    </li>
                    <li>
                      <span>Competition</span>
                    </li>
                    <li>
                      <span>Channels used</span>
                    </li>
                  </ul>
                  <p>
                    We help you define a realistic budget that delivers results.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What happens after campaigns are launched?">
                  <p>We don’t “set and forget.” We continuously:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Monitor performance</span>
                    </li>
                    <li>
                      <span>Optimize campaigns</span>
                    </li>
                    <li>
                      <span>Improve results</span>
                    </li>
                  </ul>
                  <p>This is where real growth happens.</p>
                </FaqCardList>
                <FaqCardList faq="Will I receive reports and updates?">
                  <p>Yes. You’ll get:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Performance reports</span>
                    </li>
                    <li>
                      <span>Insights and recommendations</span>
                    </li>
                    <li>
                      <span>Progress updates</span>
                    </li>
                  </ul>
                  <p>Full transparency at all times.</p>
                </FaqCardList>
                <FaqCardList faq="Do you guarantee results?">
                  <p>
                    No serious marketer can guarantee exact results. But we
                    guarantee:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Best practices</span>
                    </li>
                    <li>
                      <span>Continuous optimization</span>
                    </li>
                    <li>
                      <span>Data-driven decisions</span>
                    </li>
                  </ul>
                  <p>Our focus is delivering measurable improvement and ROI.</p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other marketers?">
                  <p>We don’t rely on guesswork.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Everything is data-driven</span>
                    </li>
                    <li>
                      <span>We focus on conversions, not vanity metrics</span>
                    </li>
                    <li>
                      <span>We align marketing with your business goals</span>
                    </li>
                  </ul>
                  <p>
                    With NTUNA.COM, you get a growth partner, not just a service
                    provider.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your business and goals</span>
                    </li>
                    <li>
                      <span>Define your marketing strategy</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Launch and optimize campaigns</span>
                    </li>
                  </ul>
                </FaqCardList>
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalMarketingFaqsBody;
